import React, { createContext, useContext, useEffect, useState } from "react";
import { onWorkflowTokenRefreshed } from "../utils/workflowSession";

// Criando o contexto
const AppContext = createContext();

// Componente Provider que irá envolver os componentes que precisam acessar o contexto
const AppContextProvider = ({ children }) => {
  const getStoredToken = () => {
    try {
      const raw = localStorage.getItem("portal_token_payload");
      return raw ? JSON.parse(raw) : "";
    } catch {
      return "";
    }
  };

  const [dateGlobal, setDateGlobal] = useState("");
  const [rowItem, setRowItem] = useState({});
  const [username, setUsername] = useState(
    () => localStorage.getItem("portal_username") || ""
  );
  const [password, setPassword] = useState(
    () => localStorage.getItem("portal_password") || ""
  );
  const [globalToken, setGlobalToken] = useState(getStoredToken);
  const [userCod, setUserCod] = useState(null);
  const [useRestTest, setUseRestTest] = useState("1");
  const [clienteCodigo, setClienteCodigo] = useState("");
  const [codClienteGlobal, setCodClienteGlobal] = useState("");

  useEffect(() => onWorkflowTokenRefreshed(setGlobalToken), []);

  return (
    <AppContext.Provider
      value={{
        codClienteGlobal,
        setCodClienteGlobal,
        clienteCodigo,
        setClienteCodigo,
        useRestTest,
        setUseRestTest,
        userCod,
        setUserCod,
        globalToken,
        setGlobalToken,
        dateGlobal,
        setDateGlobal,
        rowItem,
        setRowItem,
        username,
        setUsername,
        password,
        setPassword,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext deve ser usado dentro do AppProvider");
  }
  return context;
}

export default AppContextProvider;
